import { useFragment } from '@apollo/client';

import {
  type HeaderFooterContext,
  HeaderFooterContextFragmentFragmentDoc,
} from 'src/graphql/generated';

import { useHirerInfoContext } from '../../contexts/hirerInfo';

export const useHeaderFooterContext = () => {
  const { userId } = useHirerInfoContext();

  const fragment = useFragment<HeaderFooterContext>({
    fragment: HeaderFooterContextFragmentFragmentDoc,
    from: {
      __typename: 'HeaderFooterContext',
      user: {
        __typename: 'UserHeaderContext',
        id: userId,
      },
    },
  });

  return fragment.complete ? fragment.data : null;
};
